export const SHIPMENTS_ROUTE_PATH = 'shipments';
export const SHIPMENTS_ROUTE_PREFIX = `/${SHIPMENTS_ROUTE_PATH}`;
